module.exports = __webpack_public_path__ + "img/sumingxuan.85454555.jpg";